import { TranslationItem } from './TranslationTypes'

type Milliseconds = number

interface TranslationsMemoize {
    timestamp?: Milliseconds
    data?: TranslationItem[] | null
}

/**
 * @deprecated Use "Dictionary.fetchDictionary" instead
 * @description
 * stores memoized translations
 * */
const memoizeAndCacheFetchTranslations = () => {
    const memoize: TranslationsMemoize = {}

    /**
     * @description
     * Fetches translations from the api endpoint
     * and memoizes duplicate requests (deduping)
     * */
    const fetchTranslations = async (
        translationsURL: string,
        dedupeInterval: number = 5000
    ): Promise<TranslationItem[] | null | unknown> => {
        if (!!memoize.timestamp && !!memoize.data && memoize.timestamp + dedupeInterval > Date.now()) {
            return memoize.data
        }

        try {
            const response = await fetch(translationsURL, {
                method: 'GET',
                credentials: 'include',
            })

            if (!response.ok) {
                throw new Error(response.statusText)
            }

            const data = (await response.json())?.data
            memoize.timestamp = Date.now()
            memoize.data = data

            return data
        } catch (error) {
            return error
        }
    }

    return fetchTranslations
}

/** @deprecated Use "Dictionary.fetchDictionary" instead */
export const fetchTranslations = memoizeAndCacheFetchTranslations()
